import { useMemo } from "react"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"
import useSWR from "swr"

export type AssignableStore = {
  id: number
  name: string
  inStoreUsageEnabled: boolean
  customerAcquisitionSupportEnabled: boolean
}

export const useAssignableStoresSWR = () => {
  const url = useMemo(() => `${SMOOTH_LINE_API_URL}/base_api/smoother/stores/assignable_stores`, [])
  const { getWithToken } = useSmoothApi()

  const fetcher = async () => {
    const res = await getWithToken(url)
    const data = res.data as {
      stores: AssignableStore[]
    }
    return data
  }

  const assignableStoresSwr = useSWR(url, fetcher, {
    revalidateIfStale: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  })

  return {
    assignableStoresSwr,
  }
}
